import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";

export default function ProfileMenu() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("profile");
    localStorage.removeItem("token");
    localStorage.removeItem("rememberedEmail");
    localStorage.removeItem("status");
    localStorage.removeItem("catalogMaster");
    localStorage.removeItem("catalogValues");
    setTimeout(() => window.location.reload(), 700);
    navigate("/");
  };

  return (
    <div>
      <Button onClick={handleClick}>
        <AccountCircleOutlinedIcon className="rounded-full w-6 h-6" />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {/* Navigates to UserProfile */}
        {/* <MenuItem
          onClick={() => {
            handleClose();
            navigate("/profile");
          }}
        >
          <AccountCircleOutlinedIcon className="mr-2" /> My Profile
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            handleClose();
            navigate("/changepassword");
          }}
        >
          <LockIcon className="mr-2" /> Change Password
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            handleLogout();
          }}
        >
          <LogoutIcon className="mr-2" /> Sign Out
        </MenuItem>
      </Menu>
    </div>
  );
}
